import {createMemoryHistory, createRouter} from 'vue-router'
import pb from "./pb";

const router = createRouter({
    history: createMemoryHistory(),
    routes: [
        {
            "path": "/",
            redirect: "/menus"
        },
        {
            path: '/login',
            component: () => import('../components/Login.vue')
        },
        {
            path: '/groups',
            component: () => import('../components/Groups.vue')
        },
        {
            path: '/ingredients',
            component: () => import('../components/Ingredients.vue')
        },
        {
            path: '/dishes',
            component: () => import('../components/Dishes.vue')
        },
        {
            path: '/menus',
            component: () => import('../components/Menus.vue')
        },
        {
            path: '/debug',
            component: () => import('../components/Debug.vue')
        },
    ],
})

router.beforeEach((to, _, next) => {
    if (to.path === '/login') {
        next();
        return;
    }

    if (!pb.authStore.isValid) {
        next('/login');
        return;
    }

    next();
});

export default router